(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["favorites-page"] && !Shopify.designMode) return;
  try {
    (()=>{const e="lcs:favorites-updated",t="lcs-favorites",a=()=>`${t}-${document.documentElement.dataset.customerId||document.body.dataset.customerId||window.LCS_CUSTOMER_ID||"guest"}`,i=()=>Array.from(new Set([a(),`${t}-guest`])),s=(e,t="")=>{if(null==e)return t;if("string"==typeof e||"number"==typeof e){const a=String(e).trim();return a&&"[object Object]"!==a?a:t}return"object"==typeof e?s(e.title||e.name||e.text||e.label||e.value,t):t},n=e=>e?"string"==typeof e?e:"object"==typeof e&&(e.src||e.url||e.image||e.preview_image)||"":"",r=e=>{const t=new Set,a=[];return e.forEach((e=>{const i=(e=>{const t=(new Date).toISOString();return{key:e.key||`${e.productId||e.handle||"product"}-${e.variantId||"default"}`,productId:String(e.productId||""),variantId:String(e.variantId||""),handle:e.handle||"",title:s(e.title,""),url:e.url||"",image:n(e.image),price:s(e.price,""),compareAtPrice:s(e.compareAtPrice,""),options:Array.isArray(e.options)?e.options:[],selectedOptions:Array.isArray(e.selectedOptions)?e.selectedOptions:Array.isArray(e.options)?e.options:[],optionsWithValues:Array.isArray(e.optionsWithValues)?e.optionsWithValues:[],variants:Array.isArray(e.variants)?e.variants:[],media:Array.isArray(e.media)?e.media:[],available:!1!==e.available,color:e.color||"",size:e.size||"",quantity:Number.isFinite(Number(e.quantity))&&Number(e.quantity)>0?Math.floor(Number(e.quantity)):1,addedAt:e.addedAt||t,updatedAt:e.updatedAt||t}})(e),r=(e=>{const t=(Array.isArray(e.selectedOptions)?e.selectedOptions:[]).filter((e=>e&&e.name&&e.value)).map((e=>`${e.name}:${e.value}`)).join("|");return`${e.productId||e.handle||e.key}|${e.variantId||""}|${t}`})(i);t.has(r)||(t.add(r),a.push(i))})),a},d=()=>{try{const e=[];return i().forEach((t=>{const a=localStorage.getItem(t),i=a?JSON.parse(a):[];Array.isArray(i)&&e.push(...i.filter(Boolean))})),r(e)}catch(e){return[]}},o=e=>{const t="number"==typeof e?e:d().length;document.querySelectorAll("[data-header-favorites-count]").forEach((e=>{e.textContent=String(t),e.hidden=t<=0})),document.querySelectorAll("[data-lcs-favorites-page-count]").forEach((e=>{e.textContent=String(t)}))},c=t=>{const s=r(Array.isArray(t)?t:[]),n=a();return localStorage.setItem(n,JSON.stringify(s)),i().forEach((e=>{e!==n&&localStorage.removeItem(e)})),window.dispatchEvent(new CustomEvent(e,{detail:{count:s.length,items:s}})),o(s.length),s};window.LCSFavorites={...window.LCSFavorites||{},EVENT_UPDATED:e,read:d,write:c,writeQuietly:e=>{const t=r(Array.isArray(e)?e:[]),s=a();return localStorage.setItem(s,JSON.stringify(t)),i().forEach((e=>{e!==s&&localStorage.removeItem(e)})),o(t.length),t},remove:e=>c(d().filter((t=>t.key!==e))),removeMany:e=>{const t=new Set(e),a=d(),i=a.filter((e=>t.has(e.key))),s=a.filter((e=>!t.has(e.key)));return c(s),i},addItemsToCart:async e=>{const t=Boolean(document.querySelector('[data-lcs-favorites-page][data-quantity-discount-active="true"]')),a=e.filter((e=>e.variantId)).map((e=>{const a=Math.max(1,Math.floor(Number(e.quantity||1))),i={id:Number(e.variantId),quantity:a},s={};return t&&a>=2&&Object.assign(s,{"Quantity selected":String(a),"Deal tier":"2+ items","Deal discount":"10% off"}),e.selectionKey&&(s["_LCS selection"]=String(e.selectionKey)),Object.keys(s).length&&(i.properties=s),i}));if(!a.length)throw new Error("No valid product variant is saved for this favorite.");const i=await fetch("/cart/add.js",{method:"POST",headers:{Accept:"application/json","Content-Type":"application/json"},body:JSON.stringify({items:a})});if(!i.ok)throw new Error("Could not add favorite to cart.");return document.documentElement.dispatchEvent(new CustomEvent("cart:update",{bubbles:!0})),i.json()},updateHeaderCount:o};class l{constructor(e){this.section=e,e.__lcsFavoritesPage=this,this.grid=e.querySelector("[data-lcs-favorites-grid]"),this.empty=e.querySelector("[data-lcs-favorites-empty]"),this.toolbar=e.querySelector("[data-lcs-favorites-toolbar]"),this.template=e.querySelector("[data-lcs-favorite-card-template]"),this.selectAll=e.querySelector("[data-lcs-favorites-select-all]"),this.selectedCount=e.querySelector("[data-lcs-favorites-selected-count]"),this.notice=e.querySelector("[data-lcs-favorites-notice]"),this.loadZone=e.querySelector("[data-lcs-favorites-load-zone]"),this.sentinel=e.querySelector("[data-lcs-favorites-sentinel]"),this.expanded=e.querySelector("[data-lcs-favorite-expanded]"),this.expandedAddOption=e.querySelector("[data-lcs-expanded-add-option]"),this.expandedSelectedWrap=e.querySelector("[data-lcs-expanded-selected-wrap]"),this.expandedSelectedList=e.querySelector("[data-lcs-expanded-selected-list]"),this.expandedSelections=[],this.batchSize=Math.max(4,Number(e.dataset.batchSize||10)),this.visibleCount=this.batchSize,this.selectedKeys=new Set,this.lastRemoved=[],this.activeExpandedItem=null,this.hydratedCache=new Map,this.hydrationPromises=new Map,this.expandedOpenToken=0,this.latestRenderToken=null,this.cartUrl=e.dataset.cartUrl||"/cart",this.checkoutUrl=e.dataset.checkoutUrl||"/checkout",this.quantityDiscountActive="true"===e.dataset.quantityDiscountActive,this.messages={selectFirst:e.dataset.messageSelectFirst||"Select at least one favorite first.",added:e.dataset.messageAdded||"Added to cart.",addedSelected:e.dataset.messageAddedSelected||"Selected favorites added to cart.",cartError:e.dataset.messageCartError||"Could not add favorite to cart.",removed:e.dataset.messageRemoved||"Favorite removed.",removedMany:e.dataset.messageRemovedMany||"favorites removed.",selectedLabel:e.dataset.messageSelectedLabel||"selected",undoLabel:e.dataset.messageUndoLabel||"Undo"},this.bind(),this.render()}bind(){this.selectAll?.addEventListener("change",(()=>{const e=this.getFavorites();this.selectAll.checked?e.forEach((e=>this.selectedKeys.add(e.key))):this.selectedKeys.clear(),this.syncCheckboxes(),this.updateSelectedState()})),this.section.querySelector("[data-lcs-favorites-delete-selected]")?.addEventListener("click",(()=>this.deleteSelected())),this.section.querySelector("[data-lcs-favorites-add-selected]")?.addEventListener("click",(()=>this.addSelectedToCart(!1))),this.section.querySelector("[data-lcs-favorites-buy-selected]")?.addEventListener("click",(()=>this.addSelectedToCart(!0))),this.section.querySelectorAll("[data-lcs-expanded-close]").forEach((e=>{e.addEventListener("click",(()=>this.closeExpanded()))})),this.section.querySelector("[data-lcs-expanded-add]")?.addEventListener("click",(async()=>{await this.addExpandedItemsToCart(!1)})),this.section.querySelector("[data-lcs-expanded-buy]")?.addEventListener("click",(async()=>{await this.addExpandedItemsToCart(!0)})),this.section.querySelector("[data-lcs-expanded-remove]")?.addEventListener("click",(()=>{this.toggleExpandedFavorite()})),this.expandedAddOption?.addEventListener("click",(()=>{this.addCurrentExpandedVariantToSelection()})),window.addEventListener(e,(()=>this.render())),"IntersectionObserver"in window&&this.sentinel&&(this.observer=new IntersectionObserver((e=>{e.forEach((e=>{e.isIntersecting&&this.loadNextBatch()}))}),{rootMargin:"700px 0px"}),this.observer.observe(this.sentinel))}getFavorites(){return window.LCSFavorites&&"function"==typeof window.LCSFavorites.read?window.LCSFavorites.read():d()}escapeHtml(e){return String(e||"").replace(/[&<>"']/g,(e=>({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#039;"}[e])))}getNativeCartUrl(){const e=window.Shopify&&Shopify.routes&&Shopify.routes.root?Shopify.routes.root:"/";return`${String(e).replace(/\/?$/,"/")}cart`}redirectToCart(){document.dispatchEvent(new CustomEvent("theme:cart:refresh",{bubbles:!0})),document.documentElement.dispatchEvent(new CustomEvent("cart:refresh",{bubbles:!0}))}redirectToCheckout(){const e=this.checkoutUrl&&""!==this.checkoutUrl?this.checkoutUrl:"/checkout";window.location.assign(e)}normalizeActiveExpandedQuantity(){if(!this.activeExpandedItem)return;const e=this.section.querySelector("[data-lcs-expanded-quantity]"),t=e&&Number.isFinite(Number(e.value))&&Number(e.value)>0?Math.floor(Number(e.value)):Math.max(1,Math.floor(Number(this.activeExpandedItem.quantity||1)));this.activeExpandedItem.quantity=t,e&&(e.value=t),this.saveUpdatedFavorite(this.activeExpandedItem,!1),this.syncOriginalCardFromExpandedItem(this.activeExpandedItem)}formatMoney(e){const t=Number(e||0)/100,a=window.Shopify&&Shopify.currency&&Shopify.currency.active?Shopify.currency.active:"USD";try{return new Intl.NumberFormat(document.documentElement.lang||"en-US",{style:"currency",currency:a}).format(t)}catch(e){return`${t.toFixed(2)}`}}showNotice(e,t=!1){if(!this.notice)return;this.notice.hidden=!1,this.notice.innerHTML=t?`${this.escapeHtml(e)} <button type="button" data-lcs-favorites-undo>${this.escapeHtml(this.messages.undoLabel)}</button>`:this.escapeHtml(e);const a=this.notice.querySelector("[data-lcs-favorites-undo]");a&&a.addEventListener("click",(()=>{const e=this.getFavorites();window.LCSFavorites.write([...this.lastRemoved,...e]),this.lastRemoved=[],this.selectedKeys.clear(),this.notice.hidden=!0})),t||window.setTimeout((()=>{this.notice.hidden=!0}),2600)}async hydrateFavoriteProduct(e){if((e.optionsWithValues||[]).length&&(e.variants||[]).length&&(e.media||[]).length){const t=this.getSelectedOptionsFromItem(e);return{...e,selectedOptions:t,options:t}}if(!e.handle)return e;const t=e.handle;if(this.hydratedCache.has(t)){const a={...e,...this.hydratedCache.get(t)},i=this.getSelectedOptionsFromItem(a);return{...a,selectedOptions:i,options:i}}if(!this.hydrationPromises.has(t)){const a=fetch(`/products/${t}.js`,{headers:{Accept:"application/json"},credentials:"same-origin"}).then((e=>e.ok?e.json():null)).then((a=>{if(!a)return null;const i={title:s(e.title,s(a.title,"")),image:n(e.image)||n(a.featured_image),available:!1!==a.available,optionsWithValues:(a.options||[]).map(((e,t)=>({name:s(e&&e.name?e.name:e,`Option ${t+1}`),values:Array.isArray(e&&e.values)?e.values:Array.from(new Set((a.variants||[]).map((e=>e.options&&e.options[t])).filter(Boolean)))}))),variants:a.variants||[],media:(a.media||a.images||[]).map((e=>"string"==typeof e?{src:e,alt:s(a.title,"")}:{id:e.id,src:e.preview_image&&e.preview_image.src?e.preview_image.src:e.src||"",preview_image:e.preview_image&&e.preview_image.src?e.preview_image.src:"",alt:s(e.alt,s(a.title,""))}))};return this.hydratedCache.set(t,i),i})).finally((()=>this.hydrationPromises.delete(t)));this.hydrationPromises.set(t,a)}try{const a=await this.hydrationPromises.get(t);if(!a)return e;const i={...e,...a},s=this.getSelectedOptionsFromItem(i);return{...i,selectedOptions:s,options:s}}catch(t){return e}}getTierForQuantity(e){return this.quantityDiscountActive&&(Number.isFinite(Number(e))&&Number(e)>0?Math.floor(Number(e)):1)>=2?{label:"2+ items",discount:"10%",discountText:"10% off"}:null}updateTierElement(e,t){if(!e)return;const a=Number.isFinite(Number(t))&&Number(t)>0?Math.floor(Number(t)):1,i=this.getTierForQuantity(a);if(!i)return e.hidden=!0,e.textContent="",void e.removeAttribute("aria-label");e.hidden=!1,e.setAttribute("aria-label",`${i.label} unlocked, ${i.discountText}`),e.innerHTML=`<strong>${i.label}</strong> unlocked — <strong>${i.discountText}</strong>`}getSelectedOptionsFromItem(e){const t=Array.isArray(e.selectedOptions)?e.selectedOptions.filter((e=>e&&e.name&&e.value)):Array.isArray(e.options)?e.options.filter((e=>e&&e.name&&e.value)):[],a=Array.isArray(e.optionsWithValues)?e.optionsWithValues:[],i=Array.isArray(e.variants)?e.variants:[],n=String(e.variantId||""),r=i.find((e=>String(e&&e.id||"")===n))||i.find((e=>e&&!1!==e.available))||i[0]||null;return r&&a.length?a.map(((e,a)=>{const i=s(e&&e.name,`Option ${a+1}`),n=Array.isArray(e&&e.values)?e.values:[],d=Array.isArray(r.options)&&r.options[a]?r.options[a]:"",o=t.find((e=>e.name===i))?.value||"";return{name:i,value:d||o||n[0]||""}})).filter((e=>e.value)):t.length?t:a.map(((e,t)=>({name:s(e&&e.name,`Option ${t+1}`),value:Array.isArray(e&&e.values)&&e.values.length?e.values[0]:""}))).filter((e=>e.value))}findVariantForOptions(e,t){const a=Array.isArray(e.variants)?e.variants:[];return a.length&&t.length&&a.find((e=>{const a=Array.isArray(e.options)?e.options:[];return t.every(((e,t)=>a[t]===e.value))}))||null}findVariantImageForOption(e,t,a){const i=(Array.isArray(e.variants)?e.variants:[]).find((e=>(Array.isArray(e.options)?e.options:[])[t]===a&&e.featured_image&&e.featured_image.src));if(i&&i.featured_image&&i.featured_image.src)return i.featured_image.src;const s=Array.isArray(e.media)?e.media:[],n=String(a||"").toLowerCase().split("/")[0].split(" - ")[0].split("-")[0].split("(")[0].trim(),r=s.find((e=>{const t=String(e.alt||e.media_alt||e.title||"").toLowerCase();return n&&t.includes(n)}));return r&&(r.src||r.image||r.preview_image||r.url)||""}saveUpdatedFavorite(e,t=!0){const a=this.getFavorites().map((t=>t.key===e.key?e:t));t?window.LCSFavorites.write(a):"function"==typeof window.LCSFavorites.writeQuietly?window.LCSFavorites.writeQuietly(a):window.LCSFavorites.write(a)}applyVariantUpdate(e,t,a,i=!0){const s=this.findVariantForOptions(e,e.selectedOptions);s&&(e.variantId=String(s.id||e.variantId||""),s.price&&(e.price=this.formatMoney(s.price),a&&(a.textContent=e.price)),s.featured_image&&s.featured_image.src&&(e.image=s.featured_image.src,t&&t.src!==e.image&&(t.src=e.image,t.hidden=!1,t.removeAttribute("srcset"),t.removeAttribute("sizes"))));const n=e.selectedOptions.find((e=>/colou?r|shade|style/i.test(e.name))),r=e.selectedOptions.find((e=>/size/i.test(e.name)));if(e.color=n?n.value:"",e.size=r?r.value:"",n&&Array.isArray(e.optionsWithValues)){const a=e.optionsWithValues.findIndex((e=>e&&e.name===n.name)),i=a>=0?this.findVariantImageForOption(e,a,n.value):"";i&&(e.image=i,t&&t.src!==i&&(t.src=i,t.hidden=!1,t.removeAttribute("srcset"),t.removeAttribute("sizes")))}i&&this.saveUpdatedFavorite(e)}renderOptions(e,t,a,i="card"){if(!t)return;const n=Array.isArray(e.optionsWithValues)?e.optionsWithValues:[];if(!n.length)return void(t.hidden=!0);t.hidden=!1,t.innerHTML="";const r=this.getSelectedOptionsFromItem(e);n.forEach(((n,d)=>{const o=s(n.name,`Option ${d+1}`),c=Array.isArray(n.values)?n.values:[],l=r.find((e=>e.name===o)),u=l?l.value:c[0],h=/colou?r|shade|style/i.test(o);if("card"===i){const e=document.createElement("div");e.className="lcs-favorite-card__option";const i=document.createElement("div");i.className="lcs-favorite-card__option-label",i.textContent=o;const n=document.createElement("div");n.className="lcs-favorite-card__select-wrap";const r=document.createElement("select");return r.className="lcs-favorite-card__select",r.setAttribute("aria-label",o),c.forEach((e=>{const t=document.createElement("option");t.value=e,t.textContent=s(e,""),t.selected=e===u,r.appendChild(t)})),r.addEventListener("change",(()=>{a(o,r.value)})),n.appendChild(r),e.appendChild(i),e.appendChild(n),void t.appendChild(e)}const p=document.createElement("fieldset");p.className="pick-quick-option lcs-expanded-pick-option "+(h?"pick-quick-option--color":/size/i.test(o)?"pick-quick-option--size":"pick-quick-option--text");const m=document.createElement("legend");if(!h){const e=document.createElement("span");e.textContent=o,m.appendChild(e),p.appendChild(m)}const v=document.createElement("div");v.className="pick-quick-option__values"+(h?" pick-quick-option__values--visual pick-quick-option__values--color":/size/i.test(o)?" pick-quick-option__values--size":""),c.forEach((t=>{const i=s(t,""),n=i.split("/")[0].split(" - ")[0].split("(")[0].trim(),r=document.createElement("label");r.className="pick-quick-option__pill"+(h?" pick-quick-option__pill--visual":"");const c=document.createElement("input");c.type="radio",c.name=`expanded-${e.key}-${o}`,c.value=t,c.dataset.optionPosition=String(d+1),c.dataset.optionLabel=n,c.checked=t===u;const l=h?this.findVariantImageForOption(e,d,t):"",p=()=>{l&&this.updateMainExpandedImage(l,!1)};if(r.addEventListener("mouseenter",p),r.addEventListener("focusin",p),r.addEventListener("pointerenter",(e=>{"touch"!==e.pointerType&&p()})),c.addEventListener("change",(()=>{c.checked&&(l&&this.updateMainExpandedImage(l,!1),a(o,t))})),r.appendChild(c),h){const e=document.createElement("span");if(e.className="pick-quick-option__swatch",l){const t=document.createElement("img");t.src=l,t.alt=i,t.loading="lazy",t.decoding="async",t.draggable=!1,e.appendChild(t)}else{const t=document.createElement("span");t.textContent=n.slice(0,1),e.appendChild(t)}r.appendChild(e)}const m=document.createElement("span");m.className="pick-quick-option__text",m.textContent=h?n:i,r.appendChild(m),v.appendChild(r)})),p.appendChild(v),t.appendChild(p)}))}updateSelectedOptions(e,t,a,i,s){const n=Array.isArray(e.selectedOptions)?[...e.selectedOptions]:this.getSelectedOptionsFromItem(e),r=n.findIndex((e=>e.name===t));r>=0?n[r]={name:t,value:a}:n.push({name:t,value:a}),e.selectedOptions=n,e.options=n;const d=Array.isArray(e.optionsWithValues)?e.optionsWithValues.findIndex((e=>e.name===t)):-1;let o="";/colou?r|shade|style/i.test(t)&&d>=0&&(o=this.findVariantImageForOption(e,d,a));const c=this.findVariantForOptions(e,e.selectedOptions);c&&(e.variantId=String(c.id||e.variantId||""),c.price&&(e.price=this.formatMoney(c.price),s&&(s.textContent=e.price)),c.featured_image&&c.featured_image.src&&(e.image=c.featured_image.src,o=c.featured_image.src)),o?(e.image=o,i&&(i.src=o,i.hidden=!1,i.removeAttribute("srcset"),i.removeAttribute("sizes")),this.updateMainExpandedImage(o,!0)):i&&e.image&&(i.src=e.image,i.hidden=!1,i.removeAttribute("srcset"),i.removeAttribute("sizes"));const l=e.selectedOptions.find((e=>/colou?r|shade|style/i.test(e.name))),u=e.selectedOptions.find((e=>/size/i.test(e.name)));e.color=l?l.value:"",e.size=u?u.value:"",this.saveUpdatedFavorite(e,!1),this.syncExpandedSwatchState(e),this.syncOriginalCardFromExpandedItem(e),this.syncExpandedPurchaseState()}getMediaImages(e){const t=e.image?[e.image]:[],a=Array.isArray(e.optionsWithValues)?e.optionsWithValues.findIndex((e=>/colou?r|shade|style/i.test(e.name))):-1,i=a>=0&&e.optionsWithValues[a]&&e.optionsWithValues[a].values||[],s=[];Array.isArray(e.variants)&&a>=0&&i.length&&i.forEach((t=>{const i=e.variants.find((e=>(Array.isArray(e.options)?e.options:[])[a]===t&&e.featured_image&&e.featured_image.src));i&&i.featured_image&&i.featured_image.src&&s.push(i.featured_image.src)}));const n=Array.isArray(e.variants)?e.variants.map((e=>e&&e.featured_image&&e.featured_image.src)).filter(Boolean):[],r=Array.isArray(e.media)?e.media.map((e=>e&&(e.src||e.image||e.preview_image||e.url))).filter(Boolean):[];return Array.from(new Set([...t,...s,...n,...r].filter(Boolean)))}syncExpandedSwatchState(e){const t=this.section.querySelector("[data-lcs-expanded-selectors]");t&&e&&this.getSelectedOptionsFromItem(e).forEach((a=>{a&&a.name&&t.querySelectorAll(`input[name="expanded-${e.key}-${a.name}"]`).forEach((e=>{e.checked=e.value===a.value}))}))}updateCardVariantSummary(e,t){if(!e||!t)return;const a=e.querySelector("[data-lcs-card-variant-summary]");if(!a)return;const i=a.querySelector("[data-lcs-card-color]"),s=a.querySelector("[data-lcs-card-size]"),n=this.getSelectedOptionsFromItem(t),r=n.find((e=>/colou?r|shade|style/i.test(e.name))),d=n.find((e=>/size/i.test(e.name)));i&&(i.textContent=r?`Color: ${r.value}`:"",i.hidden=!r),s&&(s.textContent=d?`Size: ${d.value}`:"",s.hidden=!d),a.hidden=!r&&!d,e.dataset.selectedColor=r?r.value:"",e.dataset.selectedSize=d?d.value:""}syncOriginalCardFromExpandedItem(e){if(!e)return;const t=new Set;if(e.key&&this.grid){const a=window.CSS&&CSS.escape?CSS.escape(e.key):String(e.key).replace(/"/g,'"'),i=this.grid.querySelector(`[data-favorite-key="${a}"]`);i&&t.add(i)}document.querySelectorAll("[data-sqyml2-card]").forEach((a=>{const i=String(a.dataset.productId||""),s=String(a.dataset.productHandle||"");(i&&i===String(e.productId||"")||s&&s===String(e.handle||""))&&t.add(a)})),t.forEach((t=>{const a=t.querySelector("[data-lcs-favorite-image]")||t.querySelector(".lcs-favorite-card__image"),i=t.querySelector("[data-lcs-favorite-price]")||t.querySelector("[data-sqyml2-price]"),s=t.querySelector("[data-lcs-favorite-quantity]")||t.querySelector("[data-sqyml2-quantity]"),n=t.querySelector("[data-lcs-favorite-tier]")||t.querySelector("[data-sqyml2-tier]"),r=t.querySelector("[data-lcs-favorite-selectors]")||t.querySelector("[data-sqyml2-selectors]");a&&e.image&&(a.src=e.image,a.hidden=!1,a.removeAttribute("srcset"),a.removeAttribute("sizes")),i&&e.price&&(i.textContent=e.price),s&&e.quantity&&(s.value=e.quantity),n&&e.quantity&&this.updateTierElement(n,e.quantity),r&&r.querySelectorAll("select").forEach((t=>{const a=this.getSelectedOptionsFromItem(e).find((e=>e.name===t.getAttribute("aria-label")));a&&(t.value=a.value)})),t.dataset.variantId=String(e.variantId||t.dataset.variantId||""),t.dataset.productImage=String(e.image||t.dataset.productImage||""),t.dataset.productPrice=String(e.price||t.dataset.productPrice||""),t.__sqUniversalItem&&(t.__sqUniversalItem={...t.__sqUniversalItem,...e}),this.updateCardVariantSummary(t,e)}))}updateMainExpandedImage(e,t=!0){if(!e)return;const a=this.section.querySelector("[data-lcs-expanded-image]"),i=this.section.querySelector("[data-lcs-expanded-side]"),s=e=>String(e||"").split("?")[0].replace(/^https?:/,"").replace(/_(\d+x\d+|pico|icon|thumb|small|compact|medium|large|grande|original)\./,".");if(a&&s(a.src)!==s(e)&&(a.src=e,a.hidden=!1,a.removeAttribute("srcset"),a.removeAttribute("sizes")),i){let a=!1;i.querySelectorAll(".lcs-favorite-expanded__thumb").forEach((t=>{const i=s(t.dataset.expandedMediaSrc)===s(e);t.classList.toggle("is-active",i),i&&(a=!0)})),!a&&t&&i.querySelectorAll(".lcs-favorite-expanded__thumb").forEach((e=>e.classList.remove("is-active")))}t&&this.activeExpandedItem&&this.syncExpandedSwatchState(this.activeExpandedItem)}renderExpandedSideImages(e){const t=this.section.querySelector("[data-lcs-expanded-side]"),a=this.section.querySelector("[data-lcs-expanded-image]"),i=(this.section.querySelector("[data-lcs-expanded-price]"),this.section.querySelector("[data-lcs-expanded-selectors]"),this.getMediaImages(e));if(!t||!a)return;t.innerHTML="";const n=e=>String(e||"").split("?")[0].replace(/^https?:/,"").replace(/_(\d+x\d+|pico|icon|thumb|small|compact|medium|large|grande|original)\./,".");i.forEach(((a,i)=>{const r=document.createElement("button");r.type="button",r.className="lcs-favorite-expanded__thumb"+(n(a)===n(e.image)||0===i?" is-active":""),r.dataset.expandedMediaSrc=a;const d=document.createElement("img");d.src=a,d.alt=s(e.title,"Favorite image"),d.loading=i<4?"eager":"lazy",d.decoding="async",d.draggable=!1,r.appendChild(d);const o=()=>{this.updateMainExpandedImage(a,!1)};r.addEventListener("click",(()=>{this.updateMainExpandedImage(a,!1)})),r.addEventListener("mouseenter",o),r.addEventListener("pointerenter",(e=>{"touch"!==e.pointerType&&o()})),r.addEventListener("focusin",o),t.appendChild(r)})),this.syncExpandedSwatchState(e)}getExpandedFavoriteMatch(e){if(!e)return null;const t=String(e.key||"").trim(),a=String(e.handle||"").trim(),i=String(e.productId||"").trim(),s=String(e.variantId||"").trim();return this.getFavorites().find((e=>{const n=String(e.key||"").trim(),r=String(e.handle||"").trim(),d=String(e.productId||"").trim(),o=String(e.variantId||"").trim();return!!(t&&n&&t===n||s&&o&&s===o||i&&d&&i===d||a&&r&&a===r)}))||null}updateExpandedFavoriteButton(e){const t=this.section.querySelector("[data-lcs-expanded-remove]");if(!t)return;const a=Boolean(this.getExpandedFavoriteMatch(e)),i=a?"Saved":"Save";t.classList.toggle("is-saved",a),t.setAttribute("aria-label",i),t.title=a?"Remove from favorites":"Save to favorites",t.querySelectorAll("span").forEach((e=>{e.textContent=i}))}toggleExpandedFavorite(){if(!this.activeExpandedItem)return;const e=this.getExpandedFavoriteMatch(this.activeExpandedItem);if(e)return this.lastRemoved=[e],this.selectedKeys.delete(e.key),window.LCSFavorites.remove(e.key),this.showNotice(this.messages.removed,!0),this.updateExpandedFavoriteButton(this.activeExpandedItem),void this.render();const t=(new Date).toISOString(),a={...this.activeExpandedItem,key:this.activeExpandedItem.key||`${this.activeExpandedItem.productId||this.activeExpandedItem.handle||"product"}-${this.activeExpandedItem.variantId||"default"}`,quantity:Number.isFinite(Number(this.activeExpandedItem.quantity))&&Number(this.activeExpandedItem.quantity)>0?Math.floor(Number(this.activeExpandedItem.quantity)):1,addedAt:this.activeExpandedItem.addedAt||t,updatedAt:t},i=[a,...this.getFavorites().filter((e=>!this.getExpandedFavoriteMatch(a)||e.key!==a.key))];window.LCSFavorites.write(i),this.activeExpandedItem=a,this.updateExpandedFavoriteButton(this.activeExpandedItem),this.render()}syncExpandedPurchaseState(){const e=this.section.querySelector("[data-lcs-expanded-add-option]"),t=this.section.querySelector("[data-lcs-expanded-buy]"),a=this.section.querySelector("[data-lcs-expanded-add]"),i=this.expandedSelections.length>0,s=this.activeExpandedItem?this.getCurrentExpandedCartItem():null,n=s?this.getExpandedSelectionKey(s):"",r=Boolean(n&&this.expandedSelections.some((e=>e.selectionKey===n)));e&&(e.classList.toggle("is-selected",r),e.setAttribute("aria-pressed",r?"true":"false"));const d=t?.querySelector("span");d&&(d.textContent=i?"Buy Selected":"Buy Now");const o=a?.querySelector("span");o&&(o.textContent=i?"Add Selected":"Add to Cart")}getExpandedSelectionKey(e){if(!e)return"";const t=this.getSelectedOptionsFromItem(e).filter((e=>e&&e.name&&e.value)).map((e=>`${String(e.name).trim().toLowerCase()}:${String(e.value).trim().toLowerCase()}`)).join("|");return`${e.productId||e.handle||e.key||"product"}|${e.variantId||""}|${t}`}getCurrentExpandedCartItem(){if(!this.activeExpandedItem)return null;this.normalizeActiveExpandedQuantity();const e={...this.activeExpandedItem},t=this.getSelectedOptionsFromItem(e),a=this.findVariantForOptions(e,t),i=t.find((e=>/colou?r|shade|style/i.test(String(e.name||"")))),s=t.find((e=>/size/i.test(String(e.name||"")))),n=this.section.querySelector("[data-lcs-expanded-selectors] .pick-quick-option--color input:checked")?.closest("label")?.querySelector(".pick-quick-option__swatch img"),r=Array.isArray(e.optionsWithValues)&&i?e.optionsWithValues.findIndex((e=>e&&e.name===i.name)):-1;let d=a&&a.featured_image&&a.featured_image.src?a.featured_image.src:n&&n.src?n.src:r>=0?this.findVariantImageForOption(e,r,i.value):e.image||"";return a&&(e.variantId=String(a.id||e.variantId||""),a.price&&(e.price=this.formatMoney(a.price))),{...e,selectedOptions:t,options:t,color:i?i.value:"",size:s?s.value:"",image:d||e.image||"",variantId:String(e.variantId||""),quantity:Math.max(1,Math.floor(Number(e.quantity||1)))}}addCurrentExpandedVariantToSelection(){const e=this.getCurrentExpandedCartItem();if(!e||!e.variantId)return;const t=this.getSelectedOptionsFromItem(e),a=t.map((e=>e&&e.value?e.value:"")).filter(Boolean).join(" / "),i=this.getExpandedSelectionKey(e),n=this.expandedSelections.find((e=>e.selectionKey===i));n?n.quantity+=e.quantity:this.expandedSelections.push({key:i,selectionKey:i,productId:e.productId||"",handle:e.handle||"",variantId:e.variantId,quantity:e.quantity,title:a||s(e.title,"Selected option"),price:s(e.price,""),image:e.image||"",selectedOptions:t});const r=this.section.querySelector("[data-lcs-expanded-quantity]");r&&(r.value=1),this.activeExpandedItem.quantity=1,this.renderExpandedSelections(),this.syncExpandedPurchaseState()}renderExpandedSelections(){if(this.expandedSelectedWrap&&this.expandedSelectedList){if(this.expandedSelectedList.innerHTML="",!this.expandedSelections.length)return this.expandedSelectedWrap.hidden=!0,this.expandedSelectedWrap.classList.remove("has-one-selected-option","has-many-selected-options"),this.expanded?.classList.remove("has-expanded-options"),this.section.querySelector(".lcs-favorite-expanded__menu")?.classList.remove("has-expanded-options"),void this.syncExpandedPurchaseState();this.expandedSelectedWrap.hidden=!1,this.expandedSelectedWrap.classList.toggle("has-one-selected-option",1===this.expandedSelections.length),this.expandedSelectedWrap.classList.toggle("has-many-selected-options",this.expandedSelections.length>1),this.expanded?.classList.add("has-expanded-options"),this.section.querySelector(".lcs-favorite-expanded__menu")?.classList.add("has-expanded-options"),this.expandedSelections.forEach(((e,t)=>{const a=document.createElement("div");a.className="lcs-favorite-expanded__selected-item",a.dataset.lcsSelectedVariantId=String(e.variantId||""),a.dataset.lcsSelectedQuantity=String(Math.max(1,Math.floor(Number(e.quantity||1))));const i=document.createElement("img");i.src=e.image||"",i.alt=s(e.title,"Selected option");const n=document.createElement("div");n.className="lcs-selected-copy";const r=Array.isArray(e.selectedOptions)?e.selectedOptions:[],d=r.find((e=>/colou?r|shade|style/i.test(String(e.name||""))))||r[0]||null,o=r.find((e=>/size/i.test(String(e.name||""))))||r[1]||null,c=s(d&&d.value?d.value:e.title,"Color"),l=c.split("/")[0].split("(")[0].trim()||c||"Color";let u=s(o&&o.value?o.value:e.size||"","");if(!u){const t=s(e.title,"").split("/").map((e=>e.trim())).filter(Boolean);u=t.length>1?t[t.length-1]:""}const h=document.createElement("strong");h.className="lcs-selected-variant-line";const p=document.createElement("span");p.className="lcs-selected-color",p.textContent=l;const m=document.createElement("span");m.className="lcs-selected-size",m.textContent=u||"Size",h.appendChild(p),h.appendChild(m);const v=document.createElement("button");v.type="button",v.setAttribute("aria-label","Remove selected option"),v.textContent="×",v.addEventListener("click",(()=>{this.expandedSelections.splice(t,1),this.renderExpandedSelections()})),n.appendChild(h),a.appendChild(i),a.appendChild(n);const y=Math.max(1,Math.floor(+e.quantity||1));if(y>1){const e=document.createElement("em");e.className="lcs-selected-qty",e.textContent="Qty "+y,a.appendChild(e)}a.appendChild(v),this.expandedSelectedList.appendChild(a)})),this.syncExpandedPurchaseState()}}getExpandedCartItems(){if(this.expandedSelections.length)return this.expandedSelections.map((e=>({variantId:e.variantId,quantity:Math.max(1,Math.floor(Number(e.quantity||1))),selectionKey:e.selectionKey||this.getExpandedSelectionKey(e),selectedOptions:e.selectedOptions||[]})));const e=this.getCurrentExpandedCartItem();return e?[{...e,selectionKey:this.getExpandedSelectionKey(e)}]:[]}async addExpandedItemsToCart(e=!1){const t=this.getExpandedCartItems();if(t.length)try{await window.LCSFavorites.addItemsToCart(t),e?this.redirectToCheckout():this.redirectToCart()}catch(e){this.showNotice(e.message||this.messages.cartError)}else this.showNotice(this.messages.cartError)}async openExpanded(e){if(!this.expanded)return;const t=++this.expandedOpenToken,a=Number.isFinite(Number(e.quantity))&&Number(e.quantity)>0?Math.floor(Number(e.quantity)):1,i=this.getSelectedOptionsFromItem(e);this.activeExpandedItem={...e,selectedOptions:i,options:i,quantity:a},this.expandedSelections=[],this.renderExpandedSelections();const n=this.section.querySelector("[data-lcs-expanded-image]"),r=this.section.querySelector("[data-lcs-expanded-title]"),d=this.section.querySelector("[data-lcs-expanded-price]"),o=this.section.querySelector("[data-lcs-expanded-selectors]"),c=this.section.querySelector("[data-lcs-expanded-quantity]"),l=this.section.querySelector("[data-lcs-expanded-qty-minus]"),u=this.section.querySelector("[data-lcs-expanded-qty-plus]"),h=this.section.querySelector("[data-lcs-expanded-tier]"),p=this.section.querySelector(".lcs-favorite-expanded__menu"),m=this.section.querySelector("[data-lcs-expanded-side]");window.LCSExpandedModalLock?.lock(),this.expanded.classList.remove("is-ready"),this.expanded.hidden=!1,this.section.classList.add("lcs-expanded-active"),p&&(p.scrollTop=0),m&&(m.scrollTop=0),n&&(n.src=this.activeExpandedItem.image||"",n.alt=s(this.activeExpandedItem.title,"Favorite item"),n.hidden=!this.activeExpandedItem.image,n.decoding="async",n.draggable=!1),r&&(r.textContent=s(this.activeExpandedItem.title,"")),d&&(d.textContent=s(this.activeExpandedItem.price,"")),c&&(c.value=a),o&&(o.hidden=!1,o.innerHTML='<div class="lcs-expanded-options-loading" role="status" aria-live="polite"><span></span><span></span><span></span><small>Loading colors and sizes</small></div>'),m&&(m.innerHTML="");const v=()=>{if(!this.activeExpandedItem||t!==this.expandedOpenToken)return;const e=c&&Number.isFinite(Number(c.value))&&Number(c.value)>0?Math.floor(Number(c.value)):1;c&&(c.value=e),this.activeExpandedItem.quantity=e,this.updateTierElement(h,e),this.saveUpdatedFavorite(this.activeExpandedItem,!1),this.syncOriginalCardFromExpandedItem(this.activeExpandedItem)};l&&(l.onclick=()=>{c&&(c.value=Math.max(1,Number(c.value||1)-1)),v()}),u&&(u.onclick=()=>{c&&(c.value=Math.max(1,Number(c.value||1)+1)),v()}),c&&(c.oninput=v),this.updateTierElement(h,a),this.updateExpandedFavoriteButton(this.activeExpandedItem),this.syncExpandedPurchaseState(),requestAnimationFrame((()=>{t!==this.expandedOpenToken||this.expanded.hidden||this.expanded.classList.add("is-ready")}));const y=e=>{if(!e||t!==this.expandedOpenToken||this.expanded.hidden)return;const a=this.getSelectedOptionsFromItem(e);this.activeExpandedItem={...this.activeExpandedItem,...e,selectedOptions:a,options:a,quantity:this.activeExpandedItem.quantity},this.applyVariantUpdate(this.activeExpandedItem,n,d,!1),n&&(n.src=this.activeExpandedItem.image||"",n.alt=s(this.activeExpandedItem.title,"Favorite item"),n.hidden=!this.activeExpandedItem.image),r&&(r.textContent=s(this.activeExpandedItem.title,"")),d&&(d.textContent=s(this.activeExpandedItem.price,"")),this.renderOptions(this.activeExpandedItem,o,((e,t)=>{this.updateSelectedOptions(this.activeExpandedItem,e,t,n,d)}),"expanded"),this.syncExpandedSwatchState(this.activeExpandedItem),requestAnimationFrame((()=>{t!==this.expandedOpenToken||this.expanded.hidden||(this.renderExpandedSideImages(this.activeExpandedItem),p&&(p.scrollTop=0),m&&(m.scrollTop=0))})),this.updateExpandedFavoriteButton(this.activeExpandedItem),this.syncExpandedPurchaseState()};if(Array.isArray(this.activeExpandedItem.optionsWithValues)&&this.activeExpandedItem.optionsWithValues.length&&Array.isArray(this.activeExpandedItem.variants)&&this.activeExpandedItem.variants.length)y(this.activeExpandedItem);else{y(await this.hydrateFavoriteProduct(this.activeExpandedItem))}}closeExpanded(){this.expanded&&(this.expandedOpenToken+=1,this.expanded.hidden=!0,this.expanded.classList.remove("is-ready","has-expanded-options"),this.section.classList.remove("lcs-expanded-active"),this.section.querySelector(".lcs-favorite-expanded__menu")?.classList.remove("has-expanded-options"),this.activeExpandedItem=null,this.expandedSelections=[],this.renderExpandedSelections(),this.syncExpandedPurchaseState(),window.LCSExpandedModalLock?.unlock(),document.documentElement.style.overflow="",document.body.style.overflow="")}getSelectedItems(){const e=new Set(this.selectedKeys);return this.getFavorites().filter((t=>e.has(t.key)))}updateSelectedState(){const e=this.getFavorites(),t=e.length,a=Array.from(this.selectedKeys).filter((t=>e.some((e=>e.key===t))));this.selectedKeys=new Set(a),this.selectedCount&&(this.selectedCount.textContent=`${a.length} ${this.messages.selectedLabel}`),this.selectAll&&(this.selectAll.checked=t>0&&a.length===t,this.selectAll.indeterminate=a.length>0&&a.length<t)}syncCheckboxes(){this.grid.querySelectorAll("[data-lcs-favorite-card]").forEach((e=>{const t=e.querySelector("[data-lcs-favorite-checkbox]"),a=this.selectedKeys.has(e.dataset.favoriteKey);e.classList.toggle("is-selected",a),t&&(t.checked=a)}))}deleteSelected(){const e=Array.from(this.selectedKeys);e.length?(this.lastRemoved=window.LCSFavorites.removeMany(e),this.selectedKeys.clear(),this.showNotice(`${e.length} ${this.messages.removedMany}`,!0),this.render()):this.showNotice(this.messages.selectFirst)}async addSelectedToCart(e){const t=this.getSelectedItems();if(t.length)try{if(await window.LCSFavorites.addItemsToCart(t),e)return void this.redirectToCheckout();this.redirectToCart()}catch(e){this.showNotice(e.message||this.messages.cartError)}else this.showNotice(this.messages.selectFirst)}renderCard(e){const t=this.template.content.cloneNode(!0),a=t.querySelector("[data-lcs-favorite-card]"),i=t.querySelector("[data-lcs-favorite-checkbox]"),n=t.querySelector("[data-lcs-favorite-link]"),r=t.querySelector("[data-lcs-favorite-image]"),d=t.querySelector("[data-lcs-favorite-title]"),o=t.querySelector("[data-lcs-favorite-price]"),c=t.querySelector("[data-lcs-favorite-selectors]"),l=t.querySelector("[data-lcs-favorite-quantity]"),u=t.querySelector("[data-lcs-favorite-qty-minus]"),h=t.querySelector("[data-lcs-favorite-qty-plus]"),p=t.querySelector("[data-lcs-favorite-tier]"),m=e.url||"#";let v={...e,selectedOptions:this.getSelectedOptionsFromItem(e),quantity:Number.isFinite(Number(e.quantity))&&Number(e.quantity)>0?Math.floor(Number(e.quantity)):1};a.dataset.favoriteKey=v.key||"",a.dataset.productUrl=m,a.setAttribute("tabindex","0"),a.setAttribute("role","link"),n.href=m,d.href=m,d.textContent=s(v.title,"Saved item"),o.textContent=s(v.price,""),r.src=v.image||"",r.alt=s(v.title,"Saved item"),v.image||(r.hidden=!0),this.applyVariantUpdate(v,r,o,!1),this.renderOptions(v,c,((e,t)=>{this.updateSelectedOptions(v,e,t,r,o),this.updateCardVariantSummary(a,v)}),"card"),this.updateCardVariantSummary(a,v),l.value=v.quantity,this.updateTierElement(p,v.quantity);const y=()=>{const e=Number.isFinite(Number(l.value))&&Number(l.value)>0?Math.floor(Number(l.value)):1;l.value=e,v.quantity=e,this.updateTierElement(p,e),this.saveUpdatedFavorite(v,!1)};return u.addEventListener("click",(()=>{l.value=Math.max(1,Number(l.value||1)-1),y()})),h.addEventListener("click",(()=>{l.value=Math.max(1,Number(l.value||1)+1),y()})),l.addEventListener("input",y),i.checked=this.selectedKeys.has(v.key),t.querySelector("[data-lcs-favorite-remove]").addEventListener("click",(()=>{this.lastRemoved=[v],this.selectedKeys.delete(v.key),window.LCSFavorites.remove(v.key),this.showNotice(this.messages.removed,!0),this.render()})),t.querySelector("[data-lcs-favorite-add]").addEventListener("click",(async()=>{try{y(),await window.LCSFavorites.addItemsToCart([v]),this.redirectToCart()}catch(e){this.showNotice(e.message||this.messages.cartError)}})),t.querySelector("[data-lcs-favorite-buy]").addEventListener("click",(async()=>{try{y(),await window.LCSFavorites.addItemsToCart([v]),this.redirectToCheckout()}catch(e){this.showNotice(e.message||this.messages.cartError)}})),t.querySelector("[data-lcs-favorite-expand]").addEventListener("click",(()=>{this.openExpanded(v)})),(()=>{const e=this.selectedKeys.has(v.key);a.classList.toggle("is-selected",e),i.checked=e})(),t}loadNextBatch(){const e=this.getFavorites();this.visibleCount>=e.length||(this.visibleCount=Math.min(this.visibleCount+this.batchSize,e.length),this.render())}async render(){if(!this.grid||!this.template)return;const e=this.getFavorites();if(o(e.length),!e.length)return this.selectedKeys.clear(),this.grid.innerHTML="",this.empty&&(this.empty.hidden=!0,this.empty.style.display="none"),this.toolbar&&(this.toolbar.hidden=!1),this.loadZone&&(this.loadZone.hidden=!0),void this.updateSelectedState();this.empty&&(this.empty.hidden=!0,this.empty.style.display="none"),this.toolbar&&(this.toolbar.hidden=!1);const t=Date.now();this.latestRenderToken=t;const a=await Promise.all(e.map((e=>this.hydrateFavoriteProduct(e))));this.latestRenderToken===t&&(this.grid.innerHTML="",this.visibleCount>a.length&&(this.visibleCount=Math.max(this.batchSize,a.length)),a.slice(0,this.visibleCount).forEach((e=>{this.grid.appendChild(this.renderCard(e))})),this.loadZone&&(this.loadZone.hidden=!0),this.syncCheckboxes(),this.updateSelectedState())}}const u=(e=document)=>{e.querySelectorAll("[data-lcs-favorites-page]").forEach((e=>{if("true"===e.dataset.lcsFavoritesReady)return;const t=e.dataset.customerId||"guest",a="true"===e.dataset.customerLoggedIn;document.documentElement.dataset.customerId=t,document.documentElement.dataset.customerLoggedIn=a?"true":"false",window.LCS_CUSTOMER_ID=t,window.LCS_CUSTOMER_LOGGED_IN=a,e.dataset.lcsFavoritesReady="true",new l(e)})),o()};"loading"===document.readyState?document.addEventListener("DOMContentLoaded",(()=>u())):u(),document.addEventListener("shopify:section:load",(e=>{u(e.target)}))})(),(()=>{if(window.__LCS_RECOMMEND_SAVE_PATCH__)return;window.__LCS_RECOMMEND_SAVE_PATCH__=!0;const e=()=>window.LCSFavorites&&"function"==typeof window.LCSFavorites.read?window.LCSFavorites.read():[],t=e=>window.LCSFavorites&&"function"==typeof window.LCSFavorites.write&&window.LCSFavorites.write(e),a=e=>String(e||"").trim(),i=e=>`${a(e.dataset.productId)||a(e.dataset.productHandle)}|${a(e.dataset.variantId)}`,s=(e,t)=>{const s=a(e.dataset.productId),n=a(e.dataset.variantId),r=a(e.dataset.productHandle),d=i(e);return a(t.key)===d||n&&a(t.variantId)===n||s&&a(t.productId)===s||r&&a(t.handle)===r},n=(t,a=e())=>a.some((e=>s(t,e))),r=()=>{const t=e();document.querySelectorAll("[data-lcs-recommend-card]").forEach((e=>{const a=n(e,t),i=e.querySelector("[data-lcs-recommend-save]");e.classList.toggle("is-saved",a),i&&(i.hidden=!1,i.disabled=!1,i.setAttribute("aria-pressed",a?"true":"false"),i.setAttribute("aria-label",a?"Remove from favorites":"Save to favorites"),i.title=a?"Saved to favorites":"Save to favorites")}))},d=()=>setTimeout(r,80);document.addEventListener("click",(r=>{r.target.closest("[data-lcs-favorite-remove],[data-lcs-expanded-remove],[data-lcs-favorites-delete-selected],[data-lcs-favorites-select-all]")&&d();const o=r.target.closest("[data-lcs-recommend-save]");if(!o)return;r.preventDefault(),r.stopPropagation();const c=o.closest("[data-lcs-recommend-card]");if(!c||!t)return;const l=e();if(n(c,l))return t(l.filter((e=>!s(c,e)))),c.classList.remove("is-saved"),o.hidden=!1,void d();const u=(new Date).toISOString(),h={key:i(c),productId:a(c.dataset.productId),variantId:a(c.dataset.variantId),handle:a(c.dataset.productHandle),title:a(c.dataset.productTitle),url:a(c.dataset.productUrl),image:a(c.dataset.productImage),price:a(c.dataset.productPrice),compareAtPrice:"",options:[],selectedOptions:[],optionsWithValues:[],variants:[],media:[],available:!0,color:"",size:"",quantity:1,addedAt:u,updatedAt:u};t([h,...l]),c.classList.add("is-saved"),o.hidden=!1,d()}),!0),window.addEventListener("lcs:favorites-updated",r),window.addEventListener("storage",r),document.addEventListener("DOMContentLoaded",r),r()})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-favorites-base"]) return;
  try {
    
  (() => {
    if (window.__sqMenuCategoryHoverGateV2) return;
    window.__sqMenuCategoryHoverGateV2 = true;

    const HEADER_SELECTOR = '#header-component';
    const MORE_RELEASE_GRACE_MS = 3000;
    const releaseTimers = new WeakMap();
    const CATEGORY_TRIGGER_SELECTOR = [
      'header-menu .menu-list__list-item > a.menu-list__link[href]',
      'header-menu .menu-list__list-item > button.menu-list__link',
      'header-menu .menu-list__list-item > summary.menu-list__link',
      'header-menu .mega-menu__link[href]'
    ].join(',');

    function supportsDesktopHover() {
      return window.matchMedia('(min-width: 990px) and (hover: hover)').matches;
    }

    function cancelRelease(header) {
      const timer = releaseTimers.get(header);
      if (timer) window.clearTimeout(timer);
      releaseTimers.delete(header);
    }

    function armFromTarget(target) {
      if (!supportsDesktopHover() || !(target instanceof Element)) return;
      const trigger = target.closest(CATEGORY_TRIGGER_SELECTOR);
      if (!trigger || trigger.closest('[data-sq-menu-product-preview]')) return;

      const header = trigger.closest(HEADER_SELECTOR);
      if (!header) return;

      /* The More panel must be fully reset before another category opens.
         Running this from the capture-phase gate prevents overflow labels
         from remaining stamped over the next dropdown. */
      const isOverflowCategory = Boolean(trigger.closest('.menu-list__list-item[slot="overflow"]'));
      if (!isOverflowCategory && header.classList.contains('sq-more-hold-open')) {
        document.dispatchEvent(new CustomEvent('sq:more-menu-close-request', {
          detail: { header }
        }));
      }

      cancelRelease(header);
      header.classList.add('sq-menu-hover-armed');
    }

    function releaseHeader(header, immediate = false) {
      if (!header) return;
      cancelRelease(header);

      const apply = () => {
        /* More owns its armed state until the controlled close routine runs.
           Shadow/slotted submenu movement must never disarm the header. */
        if (header.classList.contains('sq-more-hold-open')) return;
        header.classList.remove('sq-menu-hover-armed');
      };

      if (immediate || !header.classList.contains('sq-more-hold-open')) {
        apply();
        return;
      }

      releaseTimers.set(header, window.setTimeout(apply, MORE_RELEASE_GRACE_MS));
    }

    document.addEventListener('pointerover', (event) => {
      const header = event.target instanceof Element ? event.target.closest(HEADER_SELECTOR) : null;
      if (header) cancelRelease(header);
      armFromTarget(event.target);
    }, true);

    document.addEventListener('focusin', (event) => {
      const header = event.target instanceof Element ? event.target.closest(HEADER_SELECTOR) : null;
      if (header) cancelRelease(header);
      armFromTarget(event.target);
    }, true);

    document.addEventListener('pointerout', (event) => {
      if (!supportsDesktopHover() || !(event.target instanceof Element)) return;
      const header = event.target.closest(HEADER_SELECTOR);
      if (!header) return;
      const next = event.relatedTarget;
      if (next instanceof Node && header.contains(next)) return;
      releaseHeader(header);
    }, true);

    document.addEventListener('focusout', (event) => {
      if (!(event.target instanceof Element)) return;
      const header = event.target.closest(HEADER_SELECTOR);
      if (!header) return;
      requestAnimationFrame(() => {
        if (header.contains(document.activeElement)) return;
        if (header.matches(':hover')) return;
        releaseHeader(header);
      });
    }, true);

    document.addEventListener('sq:header-menu-force-close', (event) => {
      const header = event.detail?.header;
      if (header instanceof Element) releaseHeader(header, true);
    });

    const desktopHoverQuery = window.matchMedia('(min-width: 990px) and (hover: hover)');
    desktopHoverQuery.addEventListener?.('change', (event) => {
      if (event.matches) return;
      document.querySelectorAll(`${HEADER_SELECTOR}.sq-menu-hover-armed`).forEach((header) => {
        releaseHeader(header, true);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    if (window.__sqMenuCategoryHoverGateV2) return;
    window.__sqMenuCategoryHoverGateV2 = true;

    const HEADER_SELECTOR = '#header-component';
    const MORE_RELEASE_GRACE_MS = 3000;
    const releaseTimers = new WeakMap();
    const CATEGORY_TRIGGER_SELECTOR = [
      'header-menu .menu-list__list-item > a.menu-list__link[href]',
      'header-menu .menu-list__list-item > button.menu-list__link',
      'header-menu .menu-list__list-item > summary.menu-list__link',
      'header-menu .mega-menu__link[href]'
    ].join(',');

    function supportsDesktopHover() {
      return window.matchMedia('(min-width: 990px) and (hover: hover)').matches;
    }

    function cancelRelease(header) {
      const timer = releaseTimers.get(header);
      if (timer) window.clearTimeout(timer);
      releaseTimers.delete(header);
    }

    function armFromTarget(target) {
      if (!supportsDesktopHover() || !(target instanceof Element)) return;
      const trigger = target.closest(CATEGORY_TRIGGER_SELECTOR);
      if (!trigger || trigger.closest('[data-sq-menu-product-preview]')) return;

      const header = trigger.closest(HEADER_SELECTOR);
      if (!header) return;

      /* The More panel must be fully reset before another category opens.
         Running this from the capture-phase gate prevents overflow labels
         from remaining stamped over the next dropdown. */
      const isOverflowCategory = Boolean(trigger.closest('.menu-list__list-item[slot="overflow"]'));
      if (!isOverflowCategory && header.classList.contains('sq-more-hold-open')) {
        document.dispatchEvent(new CustomEvent('sq:more-menu-close-request', {
          detail: { header }
        }));
      }

      cancelRelease(header);
      header.classList.add('sq-menu-hover-armed');
    }

    function releaseHeader(header, immediate = false) {
      if (!header) return;
      cancelRelease(header);

      const apply = () => {
        /* More owns its armed state until the controlled close routine runs.
           Shadow/slotted submenu movement must never disarm the header. */
        if (header.classList.contains('sq-more-hold-open')) return;
        header.classList.remove('sq-menu-hover-armed');
      };

      if (immediate || !header.classList.contains('sq-more-hold-open')) {
        apply();
        return;
      }

      releaseTimers.set(header, window.setTimeout(apply, MORE_RELEASE_GRACE_MS));
    }

    document.addEventListener('pointerover', (event) => {
      const header = event.target instanceof Element ? event.target.closest(HEADER_SELECTOR) : null;
      if (header) cancelRelease(header);
      armFromTarget(event.target);
    }, true);

    document.addEventListener('focusin', (event) => {
      const header = event.target instanceof Element ? event.target.closest(HEADER_SELECTOR) : null;
      if (header) cancelRelease(header);
      armFromTarget(event.target);
    }, true);

    document.addEventListener('pointerout', (event) => {
      if (!supportsDesktopHover() || !(event.target instanceof Element)) return;
      const header = event.target.closest(HEADER_SELECTOR);
      if (!header) return;
      const next = event.relatedTarget;
      if (next instanceof Node && header.contains(next)) return;
      releaseHeader(header);
    }, true);

    document.addEventListener('focusout', (event) => {
      if (!(event.target instanceof Element)) return;
      const header = event.target.closest(HEADER_SELECTOR);
      if (!header) return;
      requestAnimationFrame(() => {
        if (header.contains(document.activeElement)) return;
        if (header.matches(':hover')) return;
        releaseHeader(header);
      });
    }, true);

    document.addEventListener('sq:header-menu-force-close', (event) => {
      const header = event.detail?.header;
      if (header instanceof Element) releaseHeader(header, true);
    });

    const desktopHoverQuery = window.matchMedia('(min-width: 990px) and (hover: hover)');
    desktopHoverQuery.addEventListener?.('change', (event) => {
      if (event.matches) return;
      document.querySelectorAll(`${HEADER_SELECTOR}.sq-menu-hover-armed`).forEach((header) => {
        releaseHeader(header, true);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premium-conversion-product"] && !Shopify.designMode) return;
  try {
    
/* SQEX PDP Color + Gallery V8: persistent last-hover left-rail images, independently selected cart variants. */
// Capture on WINDOW: this always runs before document capture handlers,
// including the older shared product-card redirect script.
if (!window.__SQ_EX_PDP_CAPTURE_COLOR_GUARD_V4__) {
  window.__SQ_EX_PDP_CAPTURE_COLOR_GUARD_V4__ = true;
  window.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const pill = event.target.closest('.premium-product-page .premium-option-pill');
    if (!pill || event.target instanceof HTMLInputElement || event.button !== 0 ||
        event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const input = pill.querySelector('input[type="radio"]');
    if (!input || input.disabled) return;

    // Never allow a swatch image to be interpreted as an unrelated product card.
    event.preventDefault();
    event.stopImmediatePropagation();

    // Reselecting an already-checked color should also bring that color's
    // gallery back after the customer hovered another color. Cart selection
    // changes only through the existing color/size change handler.
    if (!input.checked) input.checked = true;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }, true);
}
class PremiumProductPage {
  constructor(section) {
    this.section = section;
    this.productId = Number(section.dataset.productId || 0);
    this.productPath = window.location.pathname;
    this.form = section.querySelector('form[action*="/cart/add"]');
    this.variantsScript = section.querySelector('[data-premium-variants]');
    this.variantInput = section.querySelector('[data-premium-variant-id]');
    this.quantityInput = section.querySelector('[data-premium-quantity]');
    this.quantityDisplay = section.querySelector('[data-premium-quantity-display]');
    this.quantityMinus = section.querySelector('[data-premium-quantity-minus]');
    this.quantityPlus = section.querySelector('[data-premium-quantity-plus]');
    this.quantityDealText = section.querySelector('[data-premium-quantity-deal-text]');
    this.optionInputs = Array.from(section.querySelectorAll('.premium-option-pill input'));
    this.optionGroups = Array.from(section.querySelectorAll('.premium-option-values'));
    this.mediaItems = Array.from(section.querySelectorAll('[data-premium-media]'));
    this.thumbs = Array.from(section.querySelectorAll('[data-premium-thumb]'));
    this.priceEl = section.querySelector('[data-premium-price]');
    this.comparePriceEl = section.querySelector('[data-premium-compare-price]');
    this.valueLine = section.querySelector('[data-premium-value-line]');
    this.addTextButton = section.querySelector('[data-premium-add-text]');
    this.addTextLabel = section.querySelector('[data-premium-add-text-label]');
    this.buyNowButton = section.querySelector('[data-premium-buy-now]');
    this.recommendationSliders = Array.from(section.querySelectorAll('[data-premium-recommendations]'));
    this.mainGrid = section.querySelector('[data-premium-main-grid]');
    this.galleryColumn = section.querySelector('[data-premium-gallery-column]');
    this.galleryCard = this.galleryColumn
      ? this.galleryColumn.querySelector('.premium-gallery-card')
      : null;
    this.infoCard = section.querySelector('[data-premium-info-card]');
    this.recommendationStop = section.querySelector('[data-premium-recommend-stop]');
    this.stickyTop = 18;
    this.stickyFrame = null;

    this.variants = [];
    this.currentVariant = null;
    this.committedMediaId = '';
    this.displayedColor = '';
    this.displayedMediaId = '';

    if (this.variantsScript) {
      try {
        this.variants = JSON.parse(this.variantsScript.textContent);
      } catch (error) {
        this.variants = [];
      }
    }

    this.bind();
    this.shuffleRecommendations();

    setTimeout(() => {
      this.resetRecommendationSliders();
    }, 100);

    setTimeout(() => {
      this.resetRecommendationSliders();
    }, 350);

    this.ensureAvailableSelection();
    this.syncFromSelectedOptions();
    this.updateOptionAvailability();
    this.updateOptionSliderState();
    this.setQuantity(1);
    this.syncPrice();
    this.initStickyGallery();

    window.addEventListener('resize', () => {
      this.updateOptionSliderState();
      this.scheduleStickyGalleryUpdate();
    });

    if ('ResizeObserver' in window) {
      this.optionResizeObserver = new ResizeObserver(() => {
        this.updateOptionSliderState();
      });

      this.optionGroups.forEach((group) => {
        this.optionResizeObserver.observe(group);
      });
    }
  }

  initStickyGallery() {
    if (!this.mainGrid || !this.galleryColumn || !this.galleryCard || !this.infoCard) return;
    this.stickyScrollHandler = () => this.scheduleStickyGalleryUpdate();
    window.addEventListener('scroll', this.stickyScrollHandler, { passive: true });
    window.addEventListener('orientationchange', this.stickyScrollHandler);
    if ('ResizeObserver' in window) {
      this.stickyResizeObserver = new ResizeObserver(() => this.scheduleStickyGalleryUpdate());
      [this.mainGrid, this.galleryCard, this.infoCard, this.recommendationStop]
        .filter(Boolean).forEach((node) => this.stickyResizeObserver.observe(node));
    }
    this.scheduleStickyGalleryUpdate();
  }

  scheduleStickyGalleryUpdate() {
    if (this.stickyFrame) cancelAnimationFrame(this.stickyFrame);
    this.stickyFrame = requestAnimationFrame(() => {
      this.stickyFrame = null;
      this.updateStickyGallery();
    });
  }

  resetStickyGallery() {
    if (!this.galleryColumn || !this.mainGrid) return;
    this.galleryColumn.classList.remove('is-fixed-by-premium', 'is-stopped-by-premium');
    ['position', 'top', 'left', 'width', 'zIndex'].forEach((property) => {
      this.galleryColumn.style[property] = '';
    });
    this.mainGrid.style.minHeight = '';
  }

  updateStickyGallery() {
    if (!this.mainGrid || !this.galleryColumn || !this.galleryCard || !this.infoCard) return;
    if (!window.matchMedia('(min-width: 990px)').matches) {
      this.resetStickyGallery();
      return;
    }

    const scrollY = window.scrollY || window.pageYOffset || 0;
    const grid = this.mainGrid.getBoundingClientRect();
    const info = this.infoCard.getBoundingClientRect();
    const cardHeight = this.galleryCard.getBoundingClientRect().height;
    if (!grid.width || !cardHeight || !info.width) return;

    const gap = Number.parseFloat(getComputedStyle(this.mainGrid).columnGap || '0') || 0;
    const columnWidth = Math.max(0, info.left - grid.left - gap);
    if (!columnWidth) return;

    const gridTop = grid.top + scrollY;
    const naturalGridHeight = Math.max(cardHeight, this.infoCard.offsetHeight);
    const recommendationTop = this.recommendationStop
      ? this.recommendationStop.getBoundingClientRect().top + scrollY
      : gridTop + naturalGridHeight;

    // Keep the media entirely inside the main product grid, and release the
    // sticky image immediately before Complete the Look; never float over it.
    const boundary = Math.min(gridTop + naturalGridHeight, recommendationTop - 12);
    const endingTop = Math.max(0, boundary - gridTop - cardHeight);
    const stickyStart = gridTop - this.stickyTop;
    const stickyEnd = stickyStart + endingTop;

    this.mainGrid.style.minHeight = `${naturalGridHeight}px`;
    this.galleryColumn.style.width = `${columnWidth}px`;

    const state = scrollY <= stickyStart || endingTop < 1
      ? 'initial'
      : scrollY < stickyEnd ? 'fixed' : 'ended';

    this.galleryColumn.classList.toggle('is-fixed-by-premium', state === 'fixed');
    this.galleryColumn.classList.toggle('is-stopped-by-premium', state === 'ended');
    this.galleryColumn.style.zIndex = state === 'fixed' ? '40' : '20';

    if (state === 'initial') {
      this.galleryColumn.style.position = 'relative';
      this.galleryColumn.style.top = '0px';
      this.galleryColumn.style.left = '0px';
    } else if (state === 'fixed') {
      this.galleryColumn.style.position = 'fixed';
      this.galleryColumn.style.top = `${this.stickyTop}px`;
      this.galleryColumn.style.left = `${grid.left}px`;
    } else {
      this.galleryColumn.style.position = 'absolute';
      this.galleryColumn.style.top = `${endingTop}px`;
      this.galleryColumn.style.left = '0px';
    }
  }

  bind() {
    this.thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        if (thumb.hidden) return;
        this.showMedia(thumb.dataset.premiumThumb, true);
      });
      thumb.addEventListener('mouseenter', () => this.previewMedia(thumb.dataset.premiumThumb));
      thumb.addEventListener('focusin', () => this.previewMedia(thumb.dataset.premiumThumb));
      thumb.addEventListener('mouseleave', () => this.restoreCommittedMedia());
      thumb.addEventListener('focusout', () => this.restoreCommittedMedia());
    });

    // A premium color change is local to this product, never a navigation to a sibling product.
    // Delegate once so generic global swatch handlers cannot treat these clicks as card navigation.
    this.optionGroups.forEach((group) => {
      group.addEventListener('click', (event) => {
        if (event.target.closest('.premium-option-pill')) event.stopPropagation();
      });
      group.addEventListener('change', (event) => {
        const input = event.target;
        if (!this.optionInputs.includes(input)) return;
        event.stopPropagation();
        this.commitOptionInput(input);
      });
    });

    this.optionInputs.forEach((input) => {

      const visualPill = input.closest('.premium-visual-option-pill');

      if (visualPill) {
        visualPill.addEventListener('mouseenter', () => {
          this.previewOptionInput(input);
        });

        visualPill.addEventListener('focusin', () => {
          this.previewOptionInput(input);
        });

        visualPill.addEventListener('mouseleave', () => {
          this.clearOptionPreview();
        });

        visualPill.addEventListener('focusout', () => {
          this.clearOptionPreview();
        });

      }
    });

    if (this.quantityMinus) {
      this.quantityMinus.addEventListener('click', () => {
        this.setQuantity(this.getCurrentQuantity() - 1);
      });
    }

    if (this.quantityPlus) {
      this.quantityPlus.addEventListener('click', () => {
        this.setQuantity(this.getCurrentQuantity() + 1);
      });
    }

    if (this.quantityDisplay) {
      this.quantityDisplay.addEventListener('change', () => {
        this.setQuantity(Number(this.quantityDisplay.value || 1));
      });

      this.quantityDisplay.addEventListener('input', () => {
        this.setQuantity(Number(this.quantityDisplay.value || 1));
      });
    }

    if (this.form) {
      this.form.addEventListener('submit', (event) => {
        event.preventDefault();
        this.addCurrentItemToCart(false);
      });
    }

    if (this.buyNowButton) {
      this.buyNowButton.addEventListener('click', () => {
        this.addCurrentItemToCart(true);
      });
    }
  }

  resetRecommendationSliders() {
    this.recommendationSliders.forEach((slider) => {
      slider.scrollLeft = 0;

      if (typeof slider.scrollTo === 'function') {
        slider.scrollTo({
          left: 0,
          behavior: 'auto'
        });
      }
    });
  }

  shuffleRecommendations() {
    this.recommendationSliders.forEach((slider) => {
      const cards = Array.from(slider.children).filter((card) => {
        return !card.hasAttribute('data-current-product-card');
      });

      for (let i = cards.length - 1; i > 0; i -= 1) {
        const j = Math.floor(Math.random() * (i + 1));
        slider.appendChild(cards[j]);
        cards.splice(j, 1);
      }

      requestAnimationFrame(() => {
        slider.scrollLeft = 0;

        if (typeof slider.scrollTo === 'function') {
          slider.scrollTo({
            left: 0,
            behavior: 'auto'
          });
        }
      });
    });
  }

  ensureAvailableSelection() {
    const selected = this.getSelectedOptions();
    const exact = this.findVariant(selected);
    if (exact?.available) {
      this.currentVariant = exact;
      return;
    }
    // If a currently selected combination is sold out, stay on the same PRODUCT
    // and preserve the chosen color whenever that color has an available size.
    const colorIndex = this.getColorIndex();
    const preferredColor = colorIndex >= 0 ? selected[colorIndex] : null;
    const closest = this.variants.find((variant) =>
      variant.available && (preferredColor == null || variant.options[colorIndex] === preferredColor)
    ) || this.variants.find((variant) => variant.available);
    if (closest) this.selectVariant(closest);
  }

  getColorIndex() {
    return Array.from(this.section.querySelectorAll('.premium-option-group'))
      .findIndex((group) => /color|colour/i.test(group.querySelector('legend')?.textContent || ''));
  }

  selectVariant(variant) {
    if (!variant || !this.variants.some((v) => String(v.id) === String(variant.id))) return false;
    const groups = Array.from(this.section.querySelectorAll('.premium-option-group'));
    groups.forEach((group, index) => {
      const matching = Array.from(group.querySelectorAll('.premium-option-pill input'))
        .find((input) => input.value === variant.options[index]);
      if (matching) matching.checked = true;
    });
    this.currentVariant = variant;
    return true;
  }

  updateOptionAvailability() {
    const selected = this.getSelectedOptions();
    const colorIndex = this.getColorIndex();
    this.optionInputs.forEach((input) => {
      const pill = input.closest('.premium-option-pill');
      if (!pill) return;
      const index = Number(pill.dataset.optionPosition) - 1;
      const available = this.variants.some((variant) => {
        if (!variant.available || variant.options[index] !== input.value) return false;
        // Every color remains selectable if any size is in stock. Choosing a
        // new color may adjust size; it must never select a different product.
        if (index === colorIndex) return true;
        return variant.options.every((value, pos) =>
          pos === index || !selected[pos] || value === selected[pos]
        );
      });
      pill.hidden = !available;
      pill.classList.toggle('is-unavailable', !available);
      pill.setAttribute('aria-hidden', available ? 'false' : 'true');
      input.disabled = !available;
    });
    this.updateCommittedVisualState();
    requestAnimationFrame(() => this.updateOptionSliderState());
  }

  updateOptionSliderState() {
    this.optionGroups.forEach((group) => {
      const isScrollable = group.scrollWidth > group.clientWidth + 2;
      group.classList.toggle('is-scrollable', isScrollable);
    });
  }

  getSelectedOptions() {
    // Order is Shopify's product option order (Color, Size, etc.), not
    // browser-specific object insertion order.
    return Array.from(this.section.querySelectorAll('.premium-option-group'))
      .map((group) => group.querySelector('.premium-option-pill input:checked')?.value || '');
  }

  findVariant(selectedOptions) {
    if (!selectedOptions?.length || selectedOptions.some((value) => !value)) return null;
    return this.variants.find((variant) =>
      variant.options.length === selectedOptions.length &&
      variant.options.every((value, index) => value === selectedOptions[index])
    ) || null;
  }

  getSelectedVisualOption() {
    const index = this.getColorIndex();
    const selected = this.getSelectedOptions();
    return index >= 0 && selected[index] ? this.handleize(selected[index]) : '';
  }

  syncFromSelectedOptions() {
    const variant = this.findVariant(this.getSelectedOptions());
    // Never add an old variant to cart if the current option combination fails.
    this.currentVariant = variant?.available ? variant : null;
    if (this.variantInput) this.variantInput.value = this.currentVariant?.id || '';

    const color = this.getSelectedVisualOption();
    this.section.dataset.selectedOption = color;
    this.filterMedia(color, this.currentVariant, true);
    this.updateCommittedVisualState();
    const available = Boolean(this.currentVariant);
    if (this.addTextButton) this.addTextButton.disabled = !available;
    if (this.buyNowButton) this.buyNowButton.disabled = !available;
    this.syncPrice();
  }

  commitOptionInput(input) {
    if (!input || !this.optionInputs.includes(input)) return;
    const pill = input.closest('.premium-option-pill');
    const position = Number(pill?.dataset.optionPosition || 0) - 1;
    if (position < 0 || !Number.isInteger(position)) return;
    const intended = this.getSelectedOptions();
    intended[position] = input.value;
    // Explicitly restrict the candidate set to variants of the CURRENT PRODUCT.
    const candidates = this.variants.filter((variant) =>
      variant.available && variant.options[position] === input.value
    );
    if (!candidates.length) {
      if (this.currentVariant) this.selectVariant(this.currentVariant);
      this.updateOptionAvailability();
      return;
    }
    // Prefer retaining the previously selected size and other options.
    const preferred = candidates.find((variant) =>
      variant.options.every((value, index) => index === position || value === intended[index])
    ) || candidates.slice().sort((a, b) => {
      const count = variant => variant.options.reduce((sum, value, index) =>
        sum + (index !== position && value === intended[index] ? 1 : 0), 0);
      return count(b) - count(a);
    })[0];
    const colorIndex = this.getColorIndex();
    const lastHoveredColor = position !== colorIndex ? this.displayedColor : '';
    this.selectVariant(preferred);
    this.clearOptionPreview(false);
    this.updateOptionAvailability();
    this.syncFromSelectedOptions();
    // Changing size must never make a hover-only color the purchased color.
    // Preserve the last visual preview while syncing the actual chosen variant.
    if (lastHoveredColor && lastHoveredColor !== this.getSelectedVisualOption()) {
      const preferredSizeOptions = this.getSelectedOptions();
      const previewVariant = this.variants.find((candidate) =>
        candidate.available && this.handleize(candidate.options[colorIndex]) === lastHoveredColor &&
        candidate.options.every((value, index) => index === colorIndex || value === preferredSizeOptions[index])
      ) || this.variants.find((candidate) =>
        candidate.available && this.handleize(candidate.options[colorIndex]) === lastHoveredColor
      );
      if (previewVariant) this.filterMedia(lastHoveredColor, previewVariant, false);
    }
  }

  previewOptionInput(input) {
    if (!input) return;

    const group = input.closest('.premium-option-values');
    const pill = input.closest('.premium-option-pill');

    if (group) {
      group.classList.add('is-previewing');
    }

    this.optionInputs.forEach((optionInput) => {
      const optionPill = optionInput.closest('.premium-option-pill');

      if (optionPill) {
        optionPill.classList.remove('is-preview-active');
      }
    });

    if (pill) {
      pill.classList.add('is-preview-active');
    }

    const position = Number(pill?.dataset.optionPosition || 0) - 1;
    if (position < 0) return;

    // Preview is based on a variant of THIS product only. Prefer the currently
    // selected size; if unavailable in this color, show another available size.
    const selectedOptions = this.getSelectedOptions();
    selectedOptions[position] = input.value;
    const candidates = this.variants.filter((candidate) =>
      candidate.available && candidate.options[position] === input.value
    );
    const variant = candidates.find((candidate) =>
      candidate.options.every((value, index) => index === position || value === selectedOptions[index])
    ) || candidates.find((candidate) => !!candidate.featured_media) || candidates[0];

    // Hover previews the WHOLE color gallery, not just a single main photo.
    // No radio checked state, hidden cart id, price, or currentVariant changes.
    if (position === this.getColorIndex() && variant) {
      this.filterMedia(this.handleize(input.value), variant, false);
    }
  }

  clearOptionPreview(restoreMedia = true) {
    this.optionInputs.forEach((input) => {
      input.closest('.premium-option-pill')?.classList.remove('is-preview-active');
      input.closest('.premium-option-values')?.classList.remove('is-previewing');
    });
    // Hovering a swatch is a visual choice that remains on screen. Leaving the
    // swatch removes temporary highlight only; it does NOT restore cart color.
    if (restoreMedia) this.restoreCommittedMedia();
  }

  getSelectedOptionsForPreview(previewInput) {
    const groups = {};

    this.optionInputs.forEach((input) => {
      if (input.checked) {
        groups[input.name] = input.value;
      }
    });

    if (previewInput) {
      groups[previewInput.name] = previewInput.value;
    }

    return Object.values(groups);
  }

  updateCommittedVisualState() {
    this.optionInputs.forEach((input) => {
      const pill = input.closest('.premium-option-pill');

      if (pill) {
        pill.classList.toggle('is-committed-active', input.checked);
      }
    });
  }

  getCurrentQuantity() {
    if (this.quantityDisplay) {
      return this.clampQuantity(Number(this.quantityDisplay.value || 1));
    }

    if (this.quantityInput) {
      return this.clampQuantity(Number(this.quantityInput.value || 1));
    }

    return 1;
  }

  clampQuantity(quantity) {
    const qty = Number(quantity || 1);

    if (qty < 1) {
      return 1;
    }

    return Math.floor(qty);
  }

  setQuantity(quantity) {
    const qty = this.clampQuantity(quantity);

    if (this.quantityDisplay) {
      this.quantityDisplay.value = qty;
    }

    if (this.quantityInput) {
      this.quantityInput.value = qty;
    }

    if (this.quantityDealText) {
      this.quantityDealText.textContent = `${qty} selected`;
    }

    this.syncPrice();
  }

  syncPrice() {
    const quantity = this.getCurrentQuantity();
    const variant = this.currentVariant || this.variants[0];

    if (!variant) return;

    const total = Number(variant.price || 0) * quantity;

    if (this.priceEl) {
      this.priceEl.textContent = this.formatMoney(total);
    }

    if (this.comparePriceEl) {
      this.comparePriceEl.hidden = true;
    }

    if (this.valueLine) {
      this.valueLine.textContent = `${quantity} selected · ${this.formatMoney(total)} total`;
    }

    if (this.quantityInput) {
      this.quantityInput.value = quantity;
    }

    this.updateAddButtonText();
  }

  updateAddButtonText() {
    if (!this.addTextButton || !this.addTextLabel) return;

    const singleText = this.addTextButton.dataset.singleText || 'Add to cart';
    this.addTextLabel.textContent = singleText;
  }

  getCurrentPayload() {
    const variant = this.currentVariant;
    const quantity = this.getCurrentQuantity();

    if (!variant || !variant.id || !variant.available) {
      return null;
    }

    return {
      items: [
        {
          id: Number(variant.id),
          quantity: quantity
        }
      ]
    };
  }

  async addCurrentItemToCart(goToCheckout) {
    const payload = this.getCurrentPayload();

    if (!payload || !payload.items || payload.items.length === 0) return;

    const clickedButton = goToCheckout ? this.buyNowButton : this.addTextButton;
    const originalHTML = clickedButton ? clickedButton.innerHTML : '';

    if (clickedButton) {
      clickedButton.disabled = true;
      clickedButton.innerHTML = goToCheckout
        ? '<span>Taking you to checkout...</span>'
        : '<span>Updating cart...</span>';
    }

    try {
      const addResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify(payload)
      });

      if (!addResponse.ok) {
        throw new Error('Unable to add item to cart');
      }

      if (goToCheckout) {
        window.location.href = '/checkout';
        return;
      }

      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
      window.dispatchEvent(new CustomEvent('cart:refresh'));
      window.dispatchEvent(new CustomEvent('cart:updated'));

      if (window.theme && window.theme.cart && typeof window.theme.cart.refresh === 'function') {
        window.theme.cart.refresh();
      }

      if (clickedButton) {
        clickedButton.innerHTML = '<span>Added</span>';

        window.setTimeout(() => {
          clickedButton.disabled = false;
          clickedButton.innerHTML = originalHTML;
        }, 1200);
      }
    } catch (error) {
      if (clickedButton) {
        clickedButton.disabled = false;
        clickedButton.innerHTML = originalHTML;
      }

      alert('Something went wrong. Please try again.');
    }
  }

  getColorMediaMap() {
    if (this.colorMediaMap) return this.colorMediaMap;

    // Shopify associates an image with each VARIANT, but it does not supply a
    // separate variant-to-gallery list. Imported photo sets often have opaque
    // filenames/alt text. Use the real assigned variant images as the anchors
    // for consecutive photo sets in product.media's original order.
    const mediaByColor = new Map();
    const anchorOwners = new Map();
    const colorIndex = this.getColorIndex();
    if (colorIndex < 0) return (this.colorMediaMap = mediaByColor);

    for (const variant of this.variants) {
      const color = this.handleize(variant.options?.[colorIndex]);
      if (!color) continue;
      if (!mediaByColor.has(color)) mediaByColor.set(color, new Set());
      const id = variant.featured_media?.id;
      if (!id) continue;
      const key = String(id);
      if (!anchorOwners.has(key)) anchorOwners.set(key, new Set());
      anchorOwners.get(key).add(color);
    }

    // A single-color product owns every photo, including images that are not
    // associated with a specific size or variant in Shopify.
    if (mediaByColor.size === 1) {
      const soleColor = mediaByColor.keys().next().value;
      this.mediaItems.forEach((item) => {
        mediaByColor.get(soleColor).add(String(item.dataset.premiumMedia));
      });
      return (this.colorMediaMap = mediaByColor);
    }

    // Explicitly tagged alts take precedence over position for non-anchors.
    // Use longest color first so 'army-green' is not mistaken for 'green'.
    const colorNames = [...mediaByColor.keys()].sort((a, b) => b.length - a.length);
    const explicitColorFor = (mediaGroup) => {
      const alt = this.handleize(mediaGroup || '');
      return colorNames.find((name) => alt === name || alt.startsWith(name + '-') ||
        alt.endsWith('-' + name) || alt.includes('-' + name + '-')) || '';
    };

    // When Shopify's first image is not assigned to any variant, it is still
    // the beginning of the FIRST color photo group, not a photo to discard.
    // Products such as Tassel Open Toe Sandals have this exact structure.
    const firstSingleOwner = this.mediaItems
      .map((item) => anchorOwners.get(String(item.dataset.premiumMedia || '')))
      .find((owners) => owners?.size === 1);
    let currentColor = firstSingleOwner?.values().next().value || '';
    this.mediaItems.forEach((item) => {
      const id = String(item.dataset.premiumMedia || '');
      const anchored = anchorOwners.get(id);
      let owners;
      if (anchored?.size) {
        owners = anchored;
        // An assigned image shared by different colors is common media and
        // must not establish an arbitrary following color block.
        currentColor = anchored.size === 1 ? anchored.values().next().value : '';
      } else {
        const explicitColor = explicitColorFor(item.dataset.mediaGroup);
        if (explicitColor) currentColor = explicitColor;
        owners = currentColor ? new Set([currentColor]) : null;
      }
      if (!owners) return;
      owners.forEach((color) => mediaByColor.get(color)?.add(id));
    });

    return (this.colorMediaMap = mediaByColor);
  }

  filterMedia(selectedMediaGroup, variant, saveSelection = false) {
    const selectedColor = this.handleize(selectedMediaGroup || '');
    const featuredId = variant?.featured_media?.id ? String(variant.featured_media.id) : '';
    const colorMedia = this.getColorMediaMap();
    const matchedIds = new Set(colorMedia.get(selectedColor) || []);

    // Preserve the exact selected size/variant photo, even if product.media
    // has an unusual order or that image is shared across colors.
    if (featuredId && this.mediaItems.some((item) => String(item.dataset.premiumMedia) === featuredId)) {
      matchedIds.add(featuredId);
    }

    // Avoid a blank gallery when a merchant has not assigned variant images.
    const shouldFilter = !!selectedColor && matchedIds.size > 0;
    this.mediaItems.forEach((item) => {
      const id = String(item.dataset.premiumMedia || '');
      const visible = !shouldFilter || matchedIds.has(id);
      item.hidden = !visible;
      if (!visible) item.classList.remove('is-active');
    });
    this.thumbs.forEach((thumb) => {
      const id = String(thumb.dataset.premiumThumb || '');
      const visible = !shouldFilter || matchedIds.has(id);
      thumb.hidden = !visible;
      if (!visible) thumb.classList.remove('is-active');
      // Shopify marks every thumbnail lazy by default. Hidden images will not
      // preload until visible; eagerly request only the chosen color gallery.
      if (visible) {
        const image = thumb.querySelector('img');
        if (image && image.loading !== 'eager') image.loading = 'eager';
      }
    });

    // The gallery has its own visual state, independent of the checked swatch.
    // It can show the last HOVERED color while purchase remains the clicked one.
    if (selectedColor !== this.displayedColor) {
      const belt = this.section.querySelector('.premium-gallery-card__belt');
      if (belt) belt.scrollTop = 0;
    }
    this.displayedColor = selectedColor;
    this.filteredColor = selectedColor;

    const activeThumb = this.thumbs.find((thumb) =>
      !thumb.hidden && featuredId && String(thumb.dataset.premiumThumb) === featuredId
    ) || this.thumbs.find((thumb) => !thumb.hidden);
    if (activeThumb) {
      this.displayedMediaId = String(activeThumb.dataset.premiumThumb);
      this.showMedia(this.displayedMediaId, saveSelection);
    }
  }

  previewMedia(mediaId) {
    // Last-hover-wins visual selection: hovering a LEFT-RAIL thumbnail keeps
    // its image in the main stage after mouseleave or focusout, until another
    // thumbnail, color swatch, or explicit selection changes the display.
    // This is deliberately visual-only: checked options, cart variant ID,
    // selected size, pricing, and purchase state are never modified here.
    const id = String(mediaId || '');
    if (!this.mediaItems.some((item) => !item.hidden && String(item.dataset.premiumMedia) === id)) return;
    this.displayedMediaId = id;
    this.showMedia(id, false);
  }

  restoreCommittedMedia() {
    // After moving away from a thumbnail OR color swatch, restore the last
    // hovered color's chosen large photo, not the purchased color's photo.
    const id = String(this.displayedMediaId || this.committedMediaId || '');
    if (id && this.mediaItems.some((item) => !item.hidden && String(item.dataset.premiumMedia) === id)) {
      this.showMedia(id, false);
    }
  }

  showMedia(mediaId, saveSelection = false) {
    const id = String(mediaId || '');
    if (!id || !this.mediaItems.some((item) => !item.hidden && String(item.dataset.premiumMedia) === id)) return;
    this.mediaItems.forEach((item) => {
      item.classList.toggle('is-active', String(item.dataset.premiumMedia) === id);
    });
    this.thumbs.forEach((thumb) => {
      thumb.classList.toggle('is-active', String(thumb.dataset.premiumThumb) === id);
    });
    const image = this.mediaItems.find((item) => String(item.dataset.premiumMedia) === id)?.querySelector('img');
    if (image && image.loading !== 'eager') image.loading = 'eager';
    if (saveSelection) {
      // Clicking a thumbnail chooses the visual frame, NOT the cart variant.
      this.displayedMediaId = id;
      if (this.displayedColor === this.getSelectedVisualOption()) this.committedMediaId = id;
    }
  }

  formatMoney(cents) {
    const amount = Number(cents || 0) / 100;
    const currencyCode = window.Shopify && Shopify.currency && Shopify.currency.active ? Shopify.currency.active : 'USD';

    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: currencyCode
      }).format(amount);
    } catch (error) {
      return `$${amount.toFixed(2)}`;
    }
  }

  handleize(value) {
    return String(value || '')
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }
}

// Shopify theme-editor section reloads do not always rerun bundled section scripts.
// Rebind only the new section, without creating duplicate handlers on existing nodes.
function initSQEXPremiumProductPages(root = document) {
  const sections = [];
  if (root.matches?.('.premium-product-page')) sections.push(root);
  root.querySelectorAll?.('.premium-product-page').forEach((section) => sections.push(section));
  sections.forEach((section) => {
    if (section.dataset.premiumLoaded === 'true') return;
    section.dataset.premiumLoaded = 'true';
    section.dataset.sqexColorFix = 'v8';
    new PremiumProductPage(section);
  });
}
initSQEXPremiumProductPages();
document.addEventListener('shopify:section:load', (event) => initSQEXPremiumProductPages(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initSQDualCategories = () => {
      const sections = Array.from(document.querySelectorAll('[data-sq-dual-category][data-enable-compact="true"]'));
      const root = document.documentElement;

      if (!sections.length) return;

      const headerSelectors = [
        'sticky-header',
        '.shopify-section-header-sticky',
        '.shopify-section-header',
        '#shopify-section-header',
        '.header-wrapper',
        '.site-header',
        'header'
      ];

      const filterSelectors = [
        '.facets-wrapper',
        '.facets-container',
        '.facet-filters',
        '.facets',
        'facet-filters-form',
        '.collection-filters',
        '.collection__filters'
      ];

      const getVisibleElement = (selectors) => {
        for (const selector of selectors) {
          const elements = Array.from(document.querySelectorAll(selector));

          for (const element of elements) {
            const rect = element.getBoundingClientRect();
            const style = window.getComputedStyle(element);

            if (
              rect.width > 0 &&
              rect.height > 0 &&
              style.display !== 'none' &&
              style.visibility !== 'hidden'
            ) {
              return element;
            }
          }
        }

        return null;
      };

      const numberFromCss = (value) => {
        const parsed = Number.parseFloat(value);
        return Number.isFinite(parsed) ? parsed : 0;
      };

      const getHeaderBottom = () => {
        const header = getVisibleElement(headerSelectors);

        if (!header) return 0;

        const rect = header.getBoundingClientRect();

        return Math.max(0, Math.round(rect.bottom));
      };

      const getPageTop = (element) => {
        if (!element) return 0;

        return element.getBoundingClientRect().top + window.scrollY;
      };

      const getOriginalFilterTop = (section, filter) => {
        if (!filter) return 0;

        if (!section.dataset.sqOriginalFilterTop) {
          section.dataset.sqOriginalFilterTop = String(getPageTop(filter));
        }

        return Number(section.dataset.sqOriginalFilterTop);
      };

      const dragBoundTracks = new WeakSet();

      const enableHorizontalDrag = (track) => {
        if (!track || dragBoundTracks.has(track)) return;
        dragBoundTracks.add(track);

        let pointerId = null;
        let startX = 0;
        let startScrollLeft = 0;
        let moved = false;

        track.addEventListener('dragstart', (event) => event.preventDefault());

        track.addEventListener('pointerdown', (event) => {
          if (event.pointerType !== 'mouse' || event.button !== 0) return;
          pointerId = event.pointerId;
          startX = event.clientX;
          startScrollLeft = track.scrollLeft;
          moved = false;
        });

        track.addEventListener('pointermove', (event) => {
          if (pointerId === null || event.pointerId !== pointerId) return;
          const distance = event.clientX - startX;
          if (!moved && Math.abs(distance) < 7) return;

          if (!moved) {
            moved = true;
            track.classList.add('is-dragging');
            try { track.setPointerCapture(pointerId); } catch (_) {}
          }

          track.scrollLeft = startScrollLeft - distance;
          event.preventDefault();
        });

        const stopDragging = (event) => {
          if (pointerId === null || (event?.pointerId != null && event.pointerId !== pointerId)) return;
          try {
            if (track.hasPointerCapture(pointerId)) track.releasePointerCapture(pointerId);
          } catch (_) {}
          pointerId = null;
          track.classList.remove('is-dragging');
        };

        track.addEventListener('pointerup', stopDragging);
        track.addEventListener('pointercancel', stopDragging);
        track.addEventListener('lostpointercapture', stopDragging);
        track.addEventListener('click', (event) => {
          if (!moved) return;
          event.preventDefault();
          event.stopPropagation();
          moved = false;
        }, true);
      };

      sections.forEach((section) => {
        section.querySelectorAll('.sq-dual-category__track, .sq-dual-category__compact-track')
          .forEach(enableHorizontalDrag);
      });

      const centerCompactTrack = (compact) => {
        const track = compact.querySelector('.sq-dual-category__compact-track');

        if (!track || track.dataset.sqCentered === 'true') return;

        const maxScroll = track.scrollWidth - track.clientWidth;

        if (maxScroll > 0) {
          track.scrollLeft = maxScroll / 2;
        }

        track.dataset.sqCentered = 'true';
      };

      const updateSection = (section) => {
        const compact = section.querySelector('[data-sq-compact-row]');
        const main = section.querySelector('[data-sq-main-row]');
        const filter = getVisibleElement(filterSelectors);

        if (!compact) return false;

        const computed = window.getComputedStyle(section);
        const fallbackHeaderOffset = numberFromCss(computed.getPropertyValue('--sq-header-offset'));
        const filterClearance = numberFromCss(computed.getPropertyValue('--sq-filter-clearance'));

        const headerBottom = getHeaderBottom() || fallbackHeaderOffset;
        const compactHeight = compact.offsetHeight || 54;

        root.style.setProperty('--sq-live-header-bottom', `${headerBottom}px`);
        root.style.setProperty('--sq-global-category-top', `${headerBottom}px`);
        root.style.setProperty('--sq-global-category-height', `${compactHeight}px`);
        root.style.setProperty('--sq-global-category-clearance', `${filterClearance}px`);

        let snapPoint = 0;

        if (filter) {
          const originalFilterTop = getOriginalFilterTop(section, filter);
          snapPoint = originalFilterTop - headerBottom;
        } else if (main) {
          const sectionTop = getPageTop(section);
          const mainHeight = main.offsetHeight || 0;

          snapPoint = sectionTop + Math.max(90, mainHeight - compactHeight - headerBottom);
        }

        const revealPoint = snapPoint + 4;
        const releasePoint = revealPoint - 54;

        const alreadyActive = section.classList.contains('is-compact-active');

        const templateName = document.querySelector('main[data-template]')?.dataset.template || '';
        const isCollectionTemplate = templateName.startsWith('collection');
        const shouldShowCompact = isCollectionTemplate
          ? alreadyActive
            ? window.scrollY >= releasePoint
            : window.scrollY >= revealPoint
          : false;

        section.classList.toggle('is-compact-active', shouldShowCompact);
        compact.setAttribute('aria-hidden', shouldShowCompact ? 'false' : 'true');

        if (shouldShowCompact) {
          centerCompactTrack(compact);
        } else {
          const track = compact.querySelector('.sq-dual-category__compact-track');

          if (track) {
            delete track.dataset.sqCentered;
          }
        }

        return shouldShowCompact;
      };

      const updateAll = () => {
        let active = false;

        sections.forEach((section) => {
          if (updateSection(section)) active = true;
        });

        root.classList.toggle('sq-dual-category-active', active);
      };

      let ticking = false;

      const requestUpdate = () => {
        if (ticking) return;

        ticking = true;

        window.requestAnimationFrame(() => {
          updateAll();
          ticking = false;
        });
      };

      updateAll();

      window.addEventListener('scroll', requestUpdate, { passive: true });

      window.addEventListener('resize', () => {
        sections.forEach((section) => {
          delete section.dataset.sqOriginalFilterTop;

          const compact = section.querySelector('[data-sq-compact-row]');
          const track = compact ? compact.querySelector('.sq-dual-category__compact-track') : null;

          if (track) {
            delete track.dataset.sqCentered;
          }
        });

        requestUpdate();
      });

      window.addEventListener('load', () => {
        sections.forEach((section) => {
          delete section.dataset.sqOriginalFilterTop;
        });

        requestUpdate();
      });

      document.addEventListener('shopify:section:load', () => {
        sections.forEach((section) => {
          delete section.dataset.sqOriginalFilterTop;
        });

        requestUpdate();
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initSQDualCategories);
    } else {
      initSQDualCategories();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
